export const EDD_METHOD_OPTIONS = [
  { label: "LMP (Last Menstrual Period)", value: "LMP" },
  { label: "USS (Ultrasound)", value: "USS" },
  { label: "ART (Advanced Reproductive Technology)", value: "IVF" },
  { label: "Unknown", value: "Other" },
];
